/** @format */

import React from 'react'
import styled from 'styled-components'
import { _$, Copy, Icon, Tooltip } from '@king-design/react'

interface CopyButtonProps {
  className?: string
  text: string
  style?: React.CSSProperties
  color?: string
}

const CopyButton: React.FC<CopyButtonProps> = ({ className, text, color, style }) => {
  return (
    <span className={`${className} copy-button`} style={style}>
      <Tooltip content={_$('复制')}>
        <Copy text={text}>
          <Icon className="k-icon-clone" size={16} hoverable color={color} />
        </Copy>
      </Tooltip>
    </span>
  )
}

export default styled(CopyButton)`
  display: inline-block;
  height: 16px;
  .k-icon-clone {
    vertical-align: baseline;
  }
`
